import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AdvisorId, ClientId } from "../../Types";
import ValidationError from "../../ZodError";
const StytchToken = z.string().brand("StytchToken");
const FartherToken = z.string().brand("FartherToken");
const EmailAddress = z.string().email().brand("EmailAddress");
const PhoneNumber = z.string().brand("PhoneNumber");
const Response = z.union([
    z.object({
        personId: ClientId,
        personType: z.literal("Client"),
        token: FartherToken,
    }),
    z.object({
        personId: AdvisorId,
        personType: z.literal("Advisor"),
        token: FartherToken,
    }),
]);
const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/identity/authentication/session/token/stytch/exchange"
    : "https://middleware.uat.farther.com/identity/authentication/session/token/stytch/exchange";
const exchangeStytchToken = async (stytchToken, identifierType, identifier, sessionName, sessionType, now = new Date()) => {
    const prefixToken = `stytch_${stytchToken}`;
    const idemKey = `${prefixToken.slice(8, 28)}_${now.toISOString()}`;
    const res = await axios.post(url(), {
        identifier,
        identifierType,
        name: sessionName,
        sessionType,
    }, {
        headers: {
            Authorization: `Bearer ${prefixToken}`,
            Version: "20240529",
            "Idempotency-Key": idemKey,
        },
    });
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[exchangeStytchToken] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default exchangeStytchToken;
//# sourceMappingURL=exchangeStytchToken.js.map